import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import { IRadarListing, INotifier } from '../../..//models/radar.listing';
import { CommonConfig } from '../../../configs/config.common';
import * as T_T from 'cryface';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ListingsRestfulDelegate')
export class ListingsRestfulDelegate extends DataDelegate {

    constructor() {
        super('ListingsRestfulDelegate');
    }

    public async updateListing(id: string, data: IRadarListing) {
        // await T_T.delay(2000);
        // await new DummyDataDelegate().updateListingAPI(id, data);

        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        const formData = new FormData();
        formData.set('id', data.id.toString());
        formData.set('xStatus', data.status.toString());
        formData.set('xPrice', data.price.toString());
        formData.set('xMlsnumber', data.mls_number.toString());
        formData.set('xLockbox', data.lockbox.toString());
        formData.set('xInstruction', data.instruction.toString());
        const fetched = await AxiosPromise.postForm(`${apiHost}/listings/update`, formData);
        return 1;
    }

    public async addNotifier(notifier: INotifier, listingId: string) {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        const body = {
            xEmail: notifier.email,
            xNoticeFeedback: notifier.showing_feedback,
            xFirstname: notifier.first_name,
            xNoticeCancel: notifier.showing_cancel,
            xNoticeRequest: notifier.showing_request,
            xNoticeConfirm: notifier.showing_confirm,
            xLastname: notifier.last_name,
            xPhone: notifier.phone,
            xRadarListingId: listingId
        };
        const formData = new FormData();
        formData.set('xEmail', notifier.email.toString());
        formData.set('xNoticeFeedback', notifier.showing_feedback.toString());
        formData.set('xFirstname', notifier.first_name.toString());
        formData.set('xNoticeCancel', notifier.showing_cancel.toString());
        formData.set('xNoticeRequest', notifier.showing_request.toString());
        formData.set('xNoticeConfirm', notifier.showing_confirm.toString());
        formData.set('xLastname', notifier.last_name.toString());
        formData.set('xPhone', notifier.phone.toString());
        formData.set('xRadarListingId', listingId.toString());
        const fetched = await AxiosPromise.postForm(`${apiHost}/listings/notifier/addition`, formData);
        return 1;
    }

    public async allShowingAgent(id: string) {
        const commonConfig = new CommonConfig();
        const apiHost: string = commonConfig.apiHost;
        const fetched = await AxiosPromise.get(`${apiHost}/listings/agent/allShowingAgents?listingId=${id}`);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            return 0;
        }
    }

    public async batchSend(toNumList: string[], content: string) {
        const commonConfig = new CommonConfig();
        const apiHost: string = commonConfig.apiHost;
        const formData = new FormData();
        formData.set('toNumList', toNumList.join(',').toString());
        formData.set('content', content.toString());
        const fetched = await AxiosPromise.postForm(`${apiHost}/commons/sms/twilio/send`, formData);
        if (T_T.simpleDetect(fetched) && fetched.data.errorCode === 200) {
            return 1;
        } else {
            return 0;
        }
    }
}
